'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ScalableBox = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _index = require('./../ResizeWatcher/index');

var _ScalableBox = require('./ScalableBox.styled');

var S = _interopRequireWildcard(_ScalableBox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScalableBox = exports.ScalableBox = function (_React$PureComponent) {
    _inherits(ScalableBox, _React$PureComponent);

    function ScalableBox() {
        _classCallCheck(this, ScalableBox);

        var _this = _possibleConstructorReturn(this, (ScalableBox.__proto__ || Object.getPrototypeOf(ScalableBox)).apply(this, arguments));

        _this.state = {
            scale: 1
        };
        _this.containerRef = React.createRef();
        _this.updateScale = function () {
            var container = _this.containerRef.current;
            if (!container) return;
            var _this$props = _this.props,
                originalWidth = _this$props.originalWidth,
                originalHeight = _this$props.originalHeight;

            var parentContainer = container.parentElement;
            var scaleContainer = parentContainer ? parentContainer : container;
            var containerWidth = scaleContainer.clientWidth;
            var containerHeight = scaleContainer.clientHeight;
            _this.setState({
                scale: Math.min(containerWidth / originalWidth, containerHeight / originalHeight)
            });
        };
        return _this;
    }

    _createClass(ScalableBox, [{
        key: 'render',
        value: function render() {
            return React.createElement(React.Fragment, null, React.createElement(S.ScalableContent, { className: this.props.className, innerRef: this.containerRef, scale: this.state.scale }, this.props.children), React.createElement(_index.ResizeWatcher, { onResize: this.updateScale }));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateScale();
        }
    }]);

    return ScalableBox;
}(React.PureComponent);
//# sourceMappingURL=ScalableBox.js.map